<template>
    <span class="wager-wrap"
        :class="{
            'right-side': !!atRight, 
        }"
    >
        <span class="coin-box"
            :style="{'--coin-size': '14px'}"
        > 
            <CurrentCoin
                name="" 
                :size="'var(--coin-size)'"
            />
            <TransitionGroup
                v-if="!dealer"
                :name="animation?'insert':''"
                :css="animation"
            >
                <CurrentCoin v-for="item in insertCoins"
                    :key="item"
                    :size="'var(--coin-size)'"
                >
                    {{ item }}
                </CurrentCoin>
            </TransitionGroup>
        </span>
        <em class="value">
            {{ getFixed(wagerValue, 1) }} 
        </em>
    </span>
</template>

<script lang="ts" setup> 

const props = defineProps({
    wagerValue: {
        type: [String, Number],
        default: 0, 
    },
    atRight: {
        type: Boolean,
    },
    dealer: {
        type: Boolean,
    },
});

const insertCoins = ref([]);
const animation =ref(true);
let  timer01

const fnInsert = async () => {
    animation.value = true;
    for (const idx of Array(4).keys()) {
        await Promise.allSettled([
            nextTick(),
            Sleep(150),
        ]);
        insertCoins.value.push(
            Date.now(),
        );
    }
    clearTimeout(timer01);
    timer01 = setTimeout(() => {
        animation.value = false;
        insertCoins.value = [];
    }, 300);
};

onMounted(async ()=>{
    await Sleep(100);
    fnInsert(); 
});

defineExpose({
    fnInsert
})
</script>

<style lang="scss" scoped>

.wager-wrap{
    // width: 50px;
    height: 20px;
    opacity: 1;
    border-radius: 50px;
    padding: 0 3px;
    background: rgba(13, 19, 28, 0.3);
    border: 1px solid rgba(42, 53, 70, 1); 
    font-weight: 600;
    font-size: 12px;
    text-align: center; 
    display: inline-flex; 
    justify-content: center; 
    align-items: center; 
}

.coin-box{
    position: relative;
    width: var(--coin-size);
    height: var(--coin-size);
    &>*{
        position: absolute;
        top: 0;
        left: 0; 
    }
}

.value{
    padding: 0 5px;
}

.insert-enter-active,
.insert-leave-active {
    transition: all 0.5s ease;
}

.insert-enter-from,
.insert-leave-to {
    opacity: 0;
    transform: translate(-60px, -40px);
}

.right-side{
    .insert-enter-from,
    .insert-leave-to {
        transform: translate(60px, -40px);
    }
}
</style>

